import {collection, onSnapshot} from "firebase/firestore";
import {db} from "../../Security/firebase-config";
import {getImprovementNoteMapOptions} from "../../utils/teamPlanning";

export default function subscribePlannerNotes(teamId, onMaps, onNotes, options = {}) {
  let alive = true;
  const buckets = new Map(), mapListeners = new Map();
  let mapIds = null;
  const publish = () => {
    if (!alive) return;
    options.onReady?.(!!mapIds && buckets.has('general') && [...mapIds].every(id=>buckets.has(id)));
    onNotes([...buckets.values()].flat().filter(item => item.text && (options.includeResolved || (!item.archived && item.status !== 'resolved')))
      .map(item => ({...item, text: item.text, sourceType: "improvement_note", sourceId: item.id,
        sourceScope: item.scope, sourceMapId: item.mapId || null, mapName: item.mapName || null,
        scope: item.scope, mapId: item.mapId || null})));
  };
  const listen = (key, ref, metadata, valid = () => true) => onSnapshot(ref, snapshot => {
    if (!alive || !valid()) return;
    buckets.set(key, snapshot.docs.map(item => ({...item.data(), id: item.id, ...metadata()}))
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)));
    publish();
  }, error => {
    if (!alive || !valid()) return;
    buckets.delete(key); publish();
    console.warn("Could not refresh suggested improvement notes:", error);
    options.onError?.(error.message || 'Could not load improvement points.');
  });
  const stopGeneral = listen("general", collection(db, "teams", teamId, "generalSummaryFocusPoints"), () => ({scope: "general"}));
  const stopMaps = onSnapshot(collection(db, "teams", teamId, "maps"), snapshot => {
    if (!alive) return;
    const maps = snapshot.docs.map(item => ({...item.data(), id: item.id}));
    onMaps(maps);
    const mapOptions = getImprovementNoteMapOptions(maps);
    const aliases = mapOptions.filter(map=>map.id!==map.name && !mapOptions.some(other=>other.id===map.name)).map(map=>({...map,id:map.name}));
    const allMaps = [...mapOptions,...aliases];
    const ids = new Set(allMaps.map(map => map.id));
    mapIds = ids;
    for (const [id, entry] of mapListeners) {
      if (!ids.has(id)) { entry.active = false; entry.stop(); mapListeners.delete(id); buckets.delete(id); }
    }
    for (const map of allMaps) {
      const existing = mapListeners.get(map.id);
      if (existing) {
        existing.map = map;
        if (buckets.has(map.id)) buckets.set(map.id, buckets.get(map.id).map(note => ({...note, mapName: map.name})));
      } else {
        const entry = {active: true, map};
        mapListeners.set(map.id, entry);
        entry.stop = listen(map.id, collection(db, "teams", teamId, "maps", map.id, "summaryFocusPoints"),
          () => ({scope: "map", mapId: map.id, mapName: entry.map.name}), () => entry.active);
      }
    }
    publish();
  }, error => {
    if (!alive) return;
    for (const [id, entry] of mapListeners) {entry.active = false; entry.stop(); buckets.delete(id);}
    mapListeners.clear(); onMaps([]); publish();
    console.warn("Could not refresh planner maps:", error);
    options.onError?.(error.message || 'Could not load improvement point maps.');
  });
  return () => {alive = false; stopGeneral(); stopMaps(); for (const entry of mapListeners.values()) entry.stop();};
}
